import React, {Component} from 'react';
import {Popconfirm, Card, Icon, message, Empty, Avatar, Tooltip, Button, Drawer, Input, Form, Modal} from 'antd';
import {uuid} from "../utils";
import {deleteMaterialById, deleteStuffById, getRedirectXiumi, getStuffById} from "../actions/weiChat";
import { FormOutlined ,EyeOutlined} from "@ant-design/icons";
import {EditableTagGroup} from "../components/editableTagGroup";
import ContentModal from "./contentModal";
export class StuffCard extends Component {

    constructor(props){
        super(props);
        this.state = {
            fromStuff: props.fromStuff, // 区别是来自素材列表还是图文列表
            stuffId: props.stuffId,
            formId: props.formId,
            showLock: props.showLock,
            materialId: props.id || 0,
            updateDate: window.formatDate(props.updateDate),
            statusName : props.statusName,
            stuffList : props.stuffList,
            mediaCode: props.mediaCode,
            isEditMaterial:props.isEditMaterial,//是否是编辑状态
            isMerge: props.isMerge,//是否是合成状态
            checkedStuffId:0,
            openCheckedMode: props.openCheckedMode,
            isOpenEditAttr: props.isOpenEditAttr,
            edit: props.edit,
            canEdit: props.canEdit,
            message: props.message,
            contentModalVisible: false,
            viewStuffId : 0
        };
        this.reloadStuffList = props.reloadStuffList;
        this.reloadMaterialList = props.reloadMaterialList;
        this.editMaterial = props.editMaterial;
    }

    reloadMaterialList = () =>{};

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            stuffList : nextProps.stuffList,
            statusName : nextProps.statusName,
            updateDate: window.formatDate(nextProps.updateDate),
            canEdit: nextProps.canEdit
        });
    }

    reloadStuffList = () =>{};

    editStuff = () =>{
        window.weChatEditCallBackParam = true;
        window.weChatEditCallBack = this.reloadStuffList;
        let {formId, mediaCode, stuffId} = this.state;
        if(formId){
            getRedirectXiumi({"mediaId": formId,"currentMediaCode":mediaCode}, (res) => {
                window.open(res);
            });
            window.addEventListener('message',function(e){
                if(e.data === 'close'){
                    window.weChatEditCallBack(window.weChatEditCallBackParam);
                }
            },false);
        }else {
            let url = '#/wechat/135Edit/'+ mediaCode + '/' + stuffId;
            window.open(url);
        }
    };

    editMaterial = () =>{};

    deleteStuff = ()=>{
        deleteStuffById({"stuffId":this.state.stuffId}, (res) =>{
            if(res){
                message.success('删除成功',1, ()=>{
                    this.reloadStuffList(true);
                });
            }else {
                message.error('删除失败');
            }
        });
    };

    deleteMaterial = ()=>{
        deleteMaterialById({"materialId":this.state.materialId}, (res) =>{
            if(res){
                message.success('删除成功',1, ()=>{
                    this.reloadMaterialList("",true);
                });
            }else {
                message.error('删除失败');
            }
        });
    };

    setCheckedStuffId(id){
        if(this.props.openCheckedMode){
            if(this.state.checkedStuffId === id){
                return;
            }
            this.setState({
                checkedStuffId: id
            })
        }
    }

    viewStuff = (stuffId) =>{
        // this.refs["stuffId" + stuffId].viewStuff();
        this.setState({
            contentModalVisible: true,
            viewStuffId: stuffId
        })
    };

    onCancel = () =>{
        this.setState({
            contentModalVisible : false
        })
    };

    render() {
        return (this.state.stuffList && this.state.stuffList.length === 0 ? <Empty/> :
            <div style={{paddingLeft:"15px",paddingRight:"15px",width:"370px",maxWidth:"100%"}}>
                <Card title={this.state.isEditMaterial ? 
                    (this.state.isMerge ? "" : <span><Icon type="clock-circle" /> {"更新于"+ this.state.updateDate}</span>) :
                    <span><Icon type="clock-circle" />{"更新于"+ this.state.updateDate + (this.state.fromStuff ? "" : "(" + this.state.statusName +")")}</span> }
                      headStyle={{fontSize:"12px",padding:"0 10px"}}
                      bodyStyle={{padding:"10px"}} style={{position: "static"}}
                      bordered={false}

                      /*extra={this.state.isEditMaterial?(this.state.isMerge?"":<Button onClick={()=>this.viewStuff(this.state.stuffId)} type="primary" size={"small"}>查看</Button>) :
                          (this.state.showLock ?
                            <Tooltip placement="top" title={this.state.message || "查看"}><EyeOutlined style={{cursor:"pointer"}} onClick={()=>this.viewStuff(this.state.stuffId)}/></Tooltip> :
                              ( this.state.fromStuff ?
                                  <span>
                                    {/!*<Tooltip placement="top" title={"编辑"}><FormOutlined style={{cursor:"pointer"}} onClick={this.editStuff.bind(this)}/></Tooltip>*!/}
                                    <Tooltip placement="top" title={"删除"}>
                                        <Popconfirm placement="right" title={"确认删除吗？"} onConfirm={this.deleteStuff.bind(this)} okText="确认" cancelText="取消">
                                            <Icon type="delete" style={{marginLeft:"10px",cursor:"pointer"}}/>
                                        </Popconfirm>
                                    </Tooltip>
                                  </span>   :
                                  <span>
                                      <Tooltip placement="top" title={"编辑"}><FormOutlined style={{cursor:"pointer"}} onClick={() => this.editMaterial(parseInt(this.state.materialId))}/></Tooltip>
                                  {
                                      this.state.statusName && this.state.statusName === '草稿' ? <Tooltip placement="top" title={"删除"}>
                                      <Popconfirm placement="right" title={"确认删除吗？"} onConfirm={this.deleteMaterial.bind(this)} okText="确认" cancelText="取消">
                                      <Icon type="delete" style={{marginLeft:"10px",cursor:"pointer"}}/>
                                      </Popconfirm>
                                      </Tooltip> : ""
                                  }
                                  </span>))

                      }*/>
                    {this.state.stuffList && this.state.stuffList.map((item, index) => {
                        item.uuid = item.uuid?item.uuid:uuid();
                        return <Stuff dbInfo={item} setCheckedStuffId={this.setCheckedStuffId.bind(this)} openCheckedMode={this.props.openCheckedMode} ref={"stuffId"+item.id}
                                      delStuff={this.props.delStuff} upStuff={this.props.upStuff} downStuff={this.props.downStuff} viewStuff={this.viewStuff}
                                      checked={this.state.checkedStuffId!==0 && this.state.checkedStuffId===item.id} reloadStuff={this.props.reloadStuff}
                                      contentHeight={this.props.contentHeight} isOpenEditAttr={this.props.isOpenEditAttr} index={index}
                                      addStuff={this.props.addStuff} key={item.uuid} isEditMaterial={this.state.isEditMaterial}
                                      type={index === 0?"big":"small"} {...item} canEdit={this.state.canEdit}/>
                    })}
                </Card>

                <Modal title={"内容详情"} destroyOnClose={true} visible={this.state.contentModalVisible} bodyStyle={{height:"78vh"}} onCancel={this.onCancel.bind(this)} footer={null}>
                    <ContentModal materialId={this.state.materialId} viewStuffId={this.state.viewStuffId}/>
                </Modal>
            </div>
        );
    }
}

StuffCard.defaultProps = {
    edit: false,
    openCheckedMode: false,
    isMerge: false,
    isOpenEditAttr: false
};

class Stuff extends Component {

    info = this.props.dbInfo;

    constructor(props){
        super(props);
        this.state = {
            title : props.title,
            titlePic: props.titlePic,
            type: props.type,
            checked: props.checked,
            stuffId: props.id,
            isOpenEditAttr: props.isOpenEditAttr,//是否开启编辑属性的功能
            materialId : props.materialId,
            showAttr: false,//是否显示按钮区域
            canEdit: props.canEdit
        };

        if(props.onRef){
            props.onRef(this);
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState(prevState=>{
			return {
				...prevState,
				title : nextProps.title,
				titlePic: nextProps.titlePic,
				type: nextProps.type,
				checked: nextProps.checked,
				stuffId: nextProps.id,
				isOpenEditAttr: nextProps.isOpenEditAttr,//是否开启编辑属性的功能
				materialId : nextProps.materialId,
			}
        })
    }

    remove(){
        this.props.delStuff(this.props.dbInfo);
    }

    up(){
        this.props.upStuff(this.props.dbInfo);
    }

    down(){
        this.props.downStuff(this.props.dbInfo);
    }

    reload(data){
        this.props.reloadStuff(data);
    }

    view(){
        this.props.viewStuff(this.state.stuffId);
    }

    // viewStuff = () => {
    //     let content = "#/wechat/weixing/edit/"+ this.state.materialId +"/"+ this.state.stuffId;
    //     let win = window.top || window;
    //     let maxWidth = 550;
    //     let width = win.document.body.clientWidth * 0.9;
    //     width = width > maxWidth? maxWidth: width;
    //     width = width + "px";
    //     let height = win.document.body.clientHeight * 0.9 + "px";
    //     win.layer.open({
    //         type: 2,
    //         zIndex: 29991015,
    //         area: [width, height],
    //         title: '内容详情',
    //         content: content
    //     });
    // };

    showAttrArea = ()=>{
        this.setState({
            showAttr: true
        })
    };

    closeAttrArea = ()=>{
        this.setState({
            showAttr: false
        });
    };

    updateAuthor(e){
        let author = e.target.value;
        this.info.author = author;
        this.props.reloadStuff(this.info);
    }

    updateUrl(e){
        let url = e.target.value;
        if(url && !/^(http|https):\/\/.+/.test(url)){
            message.warn("原文链接不合法");
        }
        this.info.url = url;
        this.props.reloadStuff(this.info);
    }

    updateStuffTags(tags){
        this.info.labelNames = tags;
        this.props.reloadStuff(this.info);
    }
    renderAttr(){
        if(this.state.isOpenEditAttr && this.state.checked){
            return (<div style={{overflow: "hidden",textAlign:"left"}}>
                <img src={"images/icon-close.png"} style={{cursor:"pointer",position:"absolute", right:"0px", top:this.props.contentHeight/2-25+"px"}} onClick={this.showAttrArea.bind(this)}/>
                <Drawer
                    getContainer={false}
                    style={{ position: 'absolute',display:this.state.showAttr?'block':'none'}}
                    title=""
                    placement={"right"}
                    closable={false}
                    onClose={this.closeAttrArea}
                    visible={this.state.showAttr}
                >
                    <WrappedStuffAttrForm stuff={this.info} ref={that=>this.wrappedStuffAttrForm=that} updateStuffTags={this.updateStuffTags.bind(this)} updateAuthor={this.updateAuthor.bind(this)} updateUrl={this.updateUrl.bind(this)} />
                </Drawer>
            </div>);
        }
    }

    render() {
        return (this.state.type === "big" ? <BigStuff {...this.props} {...this.state} />: <SmallStuff {...this.props} {...this.state}/>)
    }

}
Stuff.defaultProps = {
    type: "big",
    addStuff:()=>{console.log("----------addStuff---------------");},
    checked: false,
    titlePic : "/cm-sites/images/material/timg.jpg",
    index: 0//位置默认为第一个
};


class BigStuff extends Stuff{

    onClick(){
        // this.props.addStuff(this.props.dbInfo);
        // if(this.props.openCheckedMode){
        //     this.props.setCheckedStuffId(this.props.id);
        // }
        this.props.viewStuff(this.state.stuffId);
    }

    render() {
        let height = "200px";
        let picDivStyle = {
            cursor:"pointer",
            height,
            background: "url("+ this.state.titlePic + ") center no-repeat",
            backgroundSize: "cover"
        };
        let titleDivStyle = {
            position:"absolute",
            bottom:"3px",
            left:"5px",
            color:"white",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display:"-webkit-box",
            WebkitLineClamp:2,
            WebkitBoxOrient: "vertical"
        };
        return (
            <div>
                <div style={{position:"relative",marginBottom:"15px",border: this.state.checked?"3px solid #0050B3":"0px", textAlign:"left"}}>
                    <div onClick={()=>this.onClick()} style={{cursor: this.props.isEditMaterial ? "pointer" : ""}}>
                        <div style={picDivStyle}/>
                        <div style={{position:"absolute", bottom:"0px", left:"0px", width:"100%", background:"#6f6b6b",opacity:"0.4",height:"50px"}}/>
                        <span style={titleDivStyle}>{this.props.title}</span>
                    </div>
                    {this.state.checked && this.state.canEdit?<div ><OperateBar stuff={this.info} remove={this.remove.bind(this)} up={this.up.bind(this)} view={this.view.bind(this)}
                                                          down={this.down.bind(this)} reload={this.reload.bind(this)} stuffHeight={height} /></div>:""}
                </div>
                {this.renderAttr()}
            </div>
        )
    }

}

class SmallStuff extends Stuff{

    onClick(){
        // if(this.props.openCheckedMode){
        //     this.props.setCheckedStuffId(this.props.id);
        // }
        this.props.viewStuff(this.state.stuffId);
    }

    height = "80px";

    getCheckedCss() {
        if (this.state.checked) {
            return {
                position: "relative",
                height: this.height,
                padding: "5px",
                border: "3px solid #0050B3",
                textAlign:"left"
            };
        } else {
            return {
                position: "relative",
                height: this.height,
                padding: "5px",
                borderTop: "1px solid #e8e8e8",
                textAlign:"left"
            };
        }
    }

    render() {
        let picDivStyle = {
            cursor:"pointer",
            width: "25%",
            height: "60px",
            background: "url("+ this.state.titlePic + ") center no-repeat",
            backgroundSize: "cover",
            position: "absolute",
            right:"5px",
            margin:"5px"
        };
        let titleDivStyle = {
            width:"70%",
            padding:"5px",
            float:"left",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display:"-webkit-box",
            WebkitLineClamp:3,
            WebkitBoxOrient: "vertical",
            minHeight: "65px"
        };
        return (
            <div>
                <div style={this.getCheckedCss()}>
                    <div>
                        <div style={titleDivStyle}>{this.props.title}</div>
                        <div style={picDivStyle} onClick={()=>this.onClick()}/>
                    </div>
                    {this.state.checked && this.state.canEdit ?<OperateBar vAlign={this.props.index>4?"bottom":"middle"} stuff={this.info} remove={this.remove.bind(this)} up={this.up.bind(this)} view={this.view.bind(this)}
                                                    down={this.down.bind(this)} reload={this.reload.bind(this)} stuffHeight={this.height} />:""}
                </div>
                {this.renderAttr()}
            </div>
        )
    }
}


class OperateBar extends Component {

    constructor(props){
        super(props);
    }

    render() {
        let width = "50px";

        const btnHeight = 30;
        let height = (btnHeight + 8 ) * 6 + 8 + "px";
        let right = (parseInt(width) + 3 + 10 + 1 + 10)*-1 + "px";

        let vAlign = (()=>{
            if(this.props.vAlign === "bottom"){
                return {bottom:"0px"};
            }else if(this.props.vAlign === "top"){
                return {top:"0px"};
            }else{
                return {top:(parseInt(height) - parseInt(this.props.stuffHeight))/-2 + "px"};
            }
        })();

        return (<div style={{position:"absolute", width, height,right, ...vAlign, border:"1px solid #e8e8e8", borderRadius:"50px", textAlign:"center"}}>
            <OperateBarBtn {...this.props} up={this.props.up} clickMethod={"arrowUp"} type={'arrow-up'} title={"上移"} />
            <OperateBarBtn {...this.props} down={this.props.down} clickMethod={"arrowDown"} type={'arrow-down'} title={"下移"} />
            <OperateBarBtn {...this.props} reload={()=>this.props.reload(this.props.stuff.id)} clickMethod={"reload"} type={'reload'} title={"刷新"} />
            <OperateBarBtn {...this.props} view={this.props.view} clickMethod={"view"} type={'eye'} title={"查看"} />
            <OperateBarBtn {...this.props} clickMethod={"edit"} type={'edit'} title={"编辑"} />
            <OperateBarBtn {...this.props} remove={this.props.remove} clickMethod={"delete"} type={'delete'} title={"移除"} />
        </div>);
    }
}
OperateBar.defaultProps = {
    vAlign:"middle"//默认居中显示， 再增加一个bottom和top显示。
}


class OperateBarBtn extends Component {

    constructor(props){
        super(props);
        this.state = {
            color: props.color,
        }
    }

    mouseOver(e){
        this.setState({
            color: "#000"
        })
    }

    mouseOut(e){
        this.setState({
            color: this.props.color
        })
    }

    onClick() {
        this[this.props.clickMethod](this.props);
    }

    arrowUp(){
        this.props.up();
    }

    arrowDown(){
        this.props.down();
    }

    reload(props){
        if(props){
            getStuffById({stuffId: props.stuff.id}, (data) => {
                props.reload(data);
            });
        }
    }

    view(){
        this.props.view();
    }

    edit(){
        let {fromId, mediaCode} = this.props.stuff;
        let stuffId = this.props.stuff.id;
        window.weChatEditCallBackParam = this.props;
        window.weChatEditCallBack = this.reload;
        if(fromId){
            getRedirectXiumi({"mediaId": fromId,"currentMediaCode":mediaCode}, (res) => {
                window.open(res);
            });
            window.addEventListener('message',function(e){
                if(e.data === 'close'){
                    window.weChatEditCallBack(window.weChatEditCallBackParam);
                }
            },false);
        }else {
            let url = '#/wechat/135Edit/'+ mediaCode + '/' + stuffId;
            window.open(url);
        }
    }

    delete(){
        this.props.remove();
    }

    render() {
        return (
            <Tooltip placement="right" title={this.props.title} style={{background:"#000"}}>
                <div onClick={()=>this.onClick()} style={{margin:"8px",cursor:"pointer"}} onMouseOut={(e)=>this.mouseOut(e)} onMouseOver={(e)=>this.mouseOver(e)}>
                    <Avatar size={30} icon={this.props.type} style={{background:this.state.color}} />
                </div>
            </Tooltip>);
    }
}
OperateBarBtn.defaultProps={
    color: "#e8e8e8",
}
export default StuffCard;


class StuffAttrForm extends Component{

    componentDidMount() {
        this.initFields(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.initFields(nextProps);
    }

    fieldData = {};
    stuff = {};

    initFields(props) {
        const { stuff } = props;
        const { setFields } = props.form;
        if(stuff && this.stuff !== stuff){
            this.stuff = stuff;
            this.fieldData = {
                author : { value: stuff.author },
                url : { value: stuff.url }
            };
            setFields(this.fieldData);
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return <Form>
            <Form.Item label="作者">
                {getFieldDecorator('author', {
                    rules: [{ required: false}],
                })(
                    <Input onBlur={(e)=>this.props.updateAuthor(e)} type="text"/>
                )}
            </Form.Item>
            <Form.Item label="原文链接">
                {getFieldDecorator('url', {
                    rules: [{ required: false, pattern: /^(http|https):\/\/.+/, message:"原文链接只能以http://或https://开头" }],
                })(
                    <Input onBlur={(e)=>this.props.updateUrl(e)} type="text"/>
                )}
            </Form.Item>
            <Form.Item label="标签">
                <EditableTagGroup onChange={this.props.updateStuffTags.bind(this)} ref={"editableTagGroup"} tags={this.stuff.labelNames} />
            </Form.Item>
        </Form>
    }
}
const WrappedStuffAttrForm = Form.create()(StuffAttrForm);